(function($) {

	$.loadComplete = function(cb) {
		var fired = false;

		function func(e) {
			// console.log(e.type);
			if (fired)
				return;

			fired = true;
			cb($);
			if (e.type == 'load')
				$(window).trigger('load');
		}

		$(document).ready(func);
		$(window).on('load', func);
	};

})(window.jQuery);
/*
* jquery-match-height 0.7.2 by @liabru
* http://brm.io/jquery-match-height/
* License MIT
*/
!function(t){"use strict";"function"==typeof define&&define.amd?define(["jquery"],t):"undefined"!=typeof module&&module.exports?module.exports=t(require("jquery")):t(jQuery)}(function(t){var e=-1,o=-1,n=function(t){return parseFloat(t)||0},a=function(e){var o=1,a=t(e),i=null,r=[];return a.each(function(){var e=t(this),a=e.offset().top-n(e.css("margin-top")),s=r.length>0?r[r.length-1]:null;null===s?r.push(e):Math.floor(Math.abs(i-a))<=o?r[r.length-1]=s.add(e):r.push(e),i=a}),r},i=function(e){var o={
byRow:!0,property:"height",target:null,remove:!1};return"object"==typeof e?t.extend(o,e):("boolean"==typeof e?o.byRow=e:"remove"===e&&(o.remove=!0),o)},r=t.fn.matchHeight=function(e){var o=i(e);if(o.remove){var n=this;return this.css(o.property,""),t.each(r._groups,function(t,e){e.elements=e.elements.not(n)}),this}return this.length<=1&&!o.target?this:(r._groups.push({elements:this,options:o}),r._apply(this,o),this)};r.version="0.7.2",r._groups=[],r._throttle=80,r._maintainScroll=!1,r._beforeUpdate=null,
r._afterUpdate=null,r._rows=a,r._parse=n,r._parseOptions=i,r._apply=function(e,o){var s=i(o),h=t(e),l=[h],c=t(window).scrollTop(),p=t("html").outerHeight(!0),u=h.parents().filter(":hidden");return u.each(function(){var e=t(this);e.data("style-cache",e.attr("style"))}),u.css("display","block"),s.byRow&&!s.target&&(h.each(function(){var e=t(this),o=e.css("display");"inline-block"!==o&&"flex"!==o&&"inline-flex"!==o&&(o="block"),e.data("style-cache",e.attr("style")),e.css({display:o,"padding-top":"0",
"padding-bottom":"0","margin-top":"0","margin-bottom":"0","border-top-width":"0","border-bottom-width":"0",height:"100px",overflow:"hidden"})}),l=a(h),h.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||"")})),t.each(l,function(e,o){var a=t(o),i=0;if(s.target)i=s.target.outerHeight(!1);else{if(s.byRow&&a.length<=1)return void a.css(s.property,"");a.each(function(){var e=t(this),o=e.attr("style"),n=e.css("display");"inline-block"!==n&&"flex"!==n&&"inline-flex"!==n&&(n="block");var a={
display:n};a[s.property]="",e.css(a),e.outerHeight(!1)>i&&(i=e.outerHeight(!1)),o?e.attr("style",o):e.css("display","")})}a.each(function(){var e=t(this),o=0;s.target&&e.is(s.target)||("border-box"!==e.css("box-sizing")&&(o+=n(e.css("border-top-width"))+n(e.css("border-bottom-width")),o+=n(e.css("padding-top"))+n(e.css("padding-bottom"))),e.css(s.property,i-o+"px"))})}),u.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||null)}),r._maintainScroll&&t(window).scrollTop(c/p*t("html").outerHeight(!0)),
this},r._applyDataApi=function(){var e={};t("[data-match-height], [data-mh]").each(function(){var o=t(this),n=o.attr("data-mh")||o.attr("data-match-height");n in e?e[n]=e[n].add(o):e[n]=o}),t.each(e,function(){this.matchHeight(!0)})};var s=function(e){r._beforeUpdate&&r._beforeUpdate(e,r._groups),t.each(r._groups,function(){r._apply(this.elements,this.options)}),r._afterUpdate&&r._afterUpdate(e,r._groups)};r._update=function(n,a){if(a&&"resize"===a.type){var i=t(window).width();if(i===e)return;e=i;
}n?o===-1&&(o=setTimeout(function(){s(a),o=-1},r._throttle)):s(a)},t(r._applyDataApi);var h=t.fn.on?"on":"bind";t(window)[h]("load",function(t){r._update(!1,t)}),t(window)[h]("resize orientationchange",function(t){r._update(!0,t)})});
/*!
	Hash Smooth Scrolling by Daniel Flynn & Bryan Oakley

	Usage:
		Add data-anchor attributes matching a link's hash to elements on the page where you would normally put an id
		Optional:
			data-anchor-min-duration	=> Controls the minimum time to scroll (default: 250ms)
			data-anchor-max-duration	=> Controls the maximum time to scroll (default: 1000ms)
			data-anchor-speed			=> Controls the speed of the scroll (default: 1 movement of the window height in px per 250ms)
			data-anchor-easing			=> Controls the easing used for the animation (default: swing)

			These can be placed on either the link, the element, or the body with the data-anchor tag. Priority is as follows: Link, Element, Body
*/
!function(a){var n=window,t="inner";"innerWidth"in window||(t="client",n=document.documentElement||document.body);var o=0,e=!1,r=a(document),i=function(n,t,i){e=!1;var s,h;i?(s=i,h=Math.min(i.prop("scrollHeight")-i.height(),n.offset().top+i.scrollTop()-i.offset().top+t.offset)):(s=r,h=Math.min(r.height()-a(window).height(),n.offset().top+t.offset)),o=s.scrollTop();var d=0,c={x:o};t.speed&&(d=Math.abs(o-h)/t.speed*1e3,d>t.maxDuration?d=t.maxDuration:d<t.minDuration&&(d=t.minDuration)),a(c).stop().animate({x:h},{duration:d,easing:t.easing,step:function(n,t){var r=Math.floor(n);if(r!=o){if(e)return void a(c).stop();o=r,s.scrollTop(r)}}})},s=function(o){var e=a('[data-anchor="'+o.hash+'"]');if(e.length||(e=a('[data-anchor="'+o.hash.substr(1)+'"]')),e.length){var r=a(e.data("anchor-parent"));r.length||(r=e.parents(".anchor-container")),o.speed=o.speed||parseInt(e.data("anchor-speed"))||parseInt(r.data("anchor-speed"))||parseInt(a("body").data("anchor-speed"))||4*n[t+"Height"],o.minDuration=o.maxDuration||parseInt(e.data("anchor-min-duration"))||parseInt(r.data("anchor-min-duration"))||parseInt(a("body").data("anchor-min-duration"))||250,o.maxDuration=o.maxDuration||parseInt(e.data("anchor-max-duration"))||parseInt(r.data("anchor-max-duration"))||parseInt(a("body").data("anchor-max-duration"))||1e3,o.easing=o.easing||e.data("anchor-easing")||r.data("anchor-easing")||a("body").data("anchor-easing")||"swing",o.offset=o.offset||e.data("anchor-offset")||r.data("anchor-offset")||a("body").data("anchor-offset")||0,o.delay?setTimeout(function(){i(e,o,r.length?r:void 0)},o.delay):i(e,o,r.length?r:void 0)}};r.on("scroll",function(){r.scrollTop()!=o&&(e=!0)}),r.on("click",'a[href*="#"]:not([href="#"])',function(){if(location.pathname.replace(/^\//,"")==this.pathname.replace(/^\//,"")&&location.hostname==this.hostname){var n=a(this);s({hash:this.hash,speed:parseInt(n.data("anchor-speed")),minDuration:parseInt(n.data("anchor-min-duration")),maxDuration:parseInt(n.data("anchor-max-duration")),easing:n.data("anchor-easing"),offset:n.data("anchor-offset")})}}),a(window).on("load",function(){location.hash&&s({hash:location.hash,delay:parseInt(a("body").data("anchor-load-delay"))})}),a.fn.smoothAnchor=function(a){s({hash:a})}}(jQuery);
//# sourceMappingURL=smooth-anchor.min.js.map
//WINDOW VIEWPORT
//Fixes issues with CSS and JS not matching up at browser/window sizes due to the scrollbar.
(function($) {
	var e = window, a = 'inner';
	if (!('innerWidth' in window )) {
		a = 'client';
		e = document.documentElement || document.body;
	}

	$.fn.viewport = function(options) {
		if (this.get(0) != window)
			return { width: this.outerWidth(), height: this.outerHeight() };
		return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
	};

	$.fn.viewportWidth = function(options) {
		if (this.get(0) != window)
			return this.outerWidth();
		return e[ a+'Width' ];
	};

	$.fn.viewportHeight = function(options) {
		if (this.get(0) != window)
			return this.outerHeight();
		return e[ a+'Height' ];
	};

	$.fn.filterByData = function(prop, val) {
		this.filter(
			function() { return $(this).data(prop)==val; }
			);
	};
})(jQuery);
jQuery.loadComplete(function($) {
	// Global vars
	var windowWidth = 0,
	windowHeight = 0,
	$scrollTop = 0,
	$self, 
	$this,
	$window = $(window),	
	$document = $(document),	
	body = $('body'),
	header = $('.header'),
	main = $('.main'),
	footer = $('.footer');

	/*====================================
	Window Events
	====================================*/

	$window.resize(function(e) {
		//Causes resize not to fire if the windows haven't actually changed (great for IE8)
		// if (windowWidth != $window.viewportWidth() || windowHeight != $window.viewportHeight()) {
		windowWidth = $window.viewportWidth();
		windowHeight = $window.viewportHeight();

			//Code goes here
		main.css('min-height', windowHeight - ( header.outerHeight(true) + footer.outerHeight(true) ) );

		if (windowWidth >= 768) {
			$('.child-menu').removeAttr('style');
			$('.menu-item-has-child').removeClass('child-menu-open');
		}

		// }
	}).resize();

	/*====================================
	Document Events
	====================================*/

	$document.scroll(function(e) {
		$scrollTop = $document.scrollTop();
		body.toggleClass('scrolled', $scrollTop > 100);
	}).scroll();

	$document.on('click', '.toggle-search', function(e) {
		e.preventDefault();
		/* Act on the event */
		body.toggleClass('search-active');
	});

	$document.on('click', '.navbar-toggler', function(e) {
		e.preventDefault();
		/* Act on the event */
		var self = $(this);
		var target = $(self.data('target'));
		target.toggleClass('menu-open');
		if (self.attr('aria-expanded') == "true") {
			self.attr('aria-expanded', 'false');
			target.slideUp(250);
		} else {
			self.attr('aria-expanded', 'true');
			target.slideDown(250);
		}
		// target.height(0);
		// setTimeout(function() {
		// 	target.height($('.mega-menu').height());
		// }, 0);
		// setTimeout(function() {
		// 	target.removeAttr('style');
		// }, 250);
	});

	$('body :not(script,sup)').contents().filter(function() {
		return this.nodeType === 3;
	}).replaceWith(function() {
		return this.nodeValue.replace(/[™®©]/g, '<sup class="super">$&</sup>');
	});

	$('.matchHeight').matchHeight();


	$(document).on('click', '.menu-item-link-has-child', function(e) {
		e.preventDefault();
		/* Act on the event */
		if (windowWidth < 768) {
			var self = $(this);
			var parent  = self.parents('.menu-item-has-child');
			var child = self.siblings('.child-menu');
			if (parent.hasClass('child-menu-open')) {
				parent.removeClass('child-menu-open');
				child.slideUp(250);
			} else {
				$('.menu-item-has-child.child-menu-open').removeClass('child-menu-open').find('.child-menu').slideUp(250);
				parent.addClass('child-menu-open');
				child.slideDown(250);
			}
		}
	});

});//End doc.ready

// $(window).on('load', function (e) {
// 	$(window).resize();
// });